import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/**
 * Input — Agent Builder's text-[13px] form input pattern.
 *
 *   text-[13px] px-3 py-2 rounded-md border
 *   bg-gray-900/40 border-gray-700 (dark) / bg-white border-gray-300 (light)
 *   focus-visible:ring-blue-500
 */
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    isDarkMode?: boolean;
    error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
    { isDarkMode = false, error, className, ...rest },
    ref,
) {
    return (
        <input
            ref={ref}
            className={cn(
                'w-full text-[13px] px-3 py-2 rounded-md border transition-colors duration-150',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-blue-500',
                'disabled:opacity-50 disabled:cursor-not-allowed',
                isDarkMode
                    ? 'bg-gray-900/40 border-gray-700 text-gray-100 placeholder:text-gray-500'
                    : 'bg-white border-gray-300 text-gray-900 placeholder:text-gray-400',
                error && (isDarkMode ? 'border-red-500' : 'border-red-500'),
                className,
            )}
            {...rest}
        />
    );
});

export default Input;
